import React from "react";
import "./floatingicon.scss";
import {
  floatingIcon,
  floatingIcon1,
  shareWhatsappIcon,
  shareWhatsappIconWhite,
  whatsAppIconNew,
  whatsAppIconInner,
} from "../../images";
import { Link } from "react-router-dom";
import useTheme from "../useTheme/useTheme";

const FloatingIcon = ({ isEnabled = true, onClick }) => {
  const { theme } = useTheme();

  if (!isEnabled) {
    return null;
  }

  const handleWhatsAppClick = () => {
    const message = "Hi";
    const phoneNumber = "919871185558";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <div className="floating_sec1">
        <Link to={() => false} onClick={handleWhatsAppClick}>
          <div className={`img_wrapper img_wrapper--${theme === "dark" ? "dark" : "light"}`}>
            <img
              src={whatsAppIconInner}
              alt="whatsapp"
              className="floating_icon1"
            />
          </div>
        </Link>
      </div>
    </>
  );
};

export default FloatingIcon;
